import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="locked-submit"
export default class extends Controller {
  static targets = [ "input", "submit" ]

  connect() {
    this.inputTarget.onchange = (e) => {
      // console.log(e.target.checked)
      if (e.target.checked) {
        // console.log(e.target.checked)
        this.submitTarget.disabled = false
        this.submitTarget.classList.remove("cursor-not-allowed", "bg-indigo-400")
        this.submitTarget.classList.add("bg-indigo-600")
      } else {
        // console.log(e.target.checked)
        this.submitTarget.disabled = true
        this.submitTarget.classList.add("bg-indigo-400", "cursor-not-allowed")
        this.submitTarget.classList.remove("bg-indigo-600")
      }
    }

    this.submitTarget.onclick = (e) => {
      if (!window.confirm("You will not be able to update these information after submit. Are you ready to submit this form?")) {
        return false
      }
    }
  }
}
